import { transform } from "lodash";
import { camelize } from "./OperatorListingJson";

export const formatValue = (value) => {
    if (typeof value === 'boolean') {
        return value ? "True" : "False";
    }
    if (value === undefined) {
        return "False"
    }
    return value;
};

// export const buildConfigurationPayload = (switchState, systemDefaults, response) => {
//     const configurations = [];

//     const findConfigByKey = (searchKey) => {
//         if (searchKey === 'csv' || searchKey === 'datalake') {
//             const config = systemDefaults.find(c => c.name === 'MLDatasource');
//             if (config) {
//                 return {
//                     config: config,
//                     keyName: searchKey,
//                     fullKey: searchKey,
//                     isMLDatasource: true
//                 };
//             }
//         }

//         const parts = searchKey.split('.');
//         for (const config of systemDefaults) {
//             const found = config.value.find(item => item.key === searchKey);
//             if (found) {
//                 return {
//                     config: config,
//                     keyName: found.key,
//                     fullKey: searchKey
//                 };
//             }
//         }

//         if (parts.length >= 2) {
//             const configName = parts[0];
//             const keyName = parts.slice(1).join('.');

//             const config = systemDefaults.find(c => c.name === configName);
//             if (config) {
//                 const found = config.value.find(item => item.key === keyName);
//                 if (found) {
//                     return {
//                         config: config,
//                         keyName: found.key,
//                         fullKey: searchKey
//                     };
//                 }
//             }
//         }

//         if (parts.length >= 3) {
//             const possibleConfigName = parts.slice(0, 2).join('.');
//             const keyName = parts.slice(2).join('.');

//             const config = systemDefaults.find(c => c.name === possibleConfigName);
//             if (config) {
//                 const found = config.value.find(item => item.key === keyName);
//                 if (found) {
//                     return {
//                         config: config,
//                         keyName: found.key,
//                         fullKey: searchKey
//                     };
//                 }
//             }
//         }

//         if (searchKey === "EIP") {
//             const config = systemDefaults.find(c => c.name === 'EIP');
//             if (config) {
//                 return {
//                     config: config,
//                     keyName: "Enabled",
//                     fullKey: "Enabled"
//                 };
//             }
//         }
//         return null;
//     };

//     const groupedConfigs = new Map();

//     Object.entries(switchState).forEach(([stateKey, value]) => {
//         const configInfo = findConfigByKey(stateKey);

//         if (!configInfo) {
//             console.warn(`No configuration found for key: ${stateKey}`);
//             return;
//         }

//         const { config, keyName } = configInfo;
//         const configName = config.name;
//         if (!groupedConfigs.has(configName)) {
//             groupedConfigs.set(configName, {
//                 config: config,
//                 values: {}
//             });
//         }
//         groupedConfigs.get(configName).values[keyName] = value;
//     });

//     groupedConfigs.forEach(({ config, values }) => {
//         const configValue = [];
//         if (config.name === 'MLDatasource') {
//             const datasources = [];
//             Object.entries(values).forEach(([key, val]) => {
//                 if (key === 'csv' && val) datasources.push('csv');
//                 if (key === 'datalake' && val) datasources.push('datalake');
//             });
//             configValue.push({
//                 key: 'Datasource',
//                 value: datasources
//             });
//         } else if (config.name === 'AgenticAI') {
//             Object.entries(values).forEach(([key, val]) => {
//                 let processedValue;
//                 if (typeof val === 'object' && val !== null && val.value) {
//                     processedValue = [val.value];
//                 } else {
//                     processedValue = [String(val)];
//                 }
//                 configValue.push({
//                     key: key,
//                     value: processedValue
//                 });
//             });
//         } else if (config.name === 'SessionExpiryTime') {
//             Object.entries(values).forEach(([key, val]) => {
//                 let processedValue;
//                 if (typeof val === 'object' && val !== null && val.value) {
//                     processedValue = [val.value];
//                 } else {
//                     processedValue = [String(val)];
//                 }
//                 configValue.push({
//                     key: key,
//                     value: processedValue
//                 });
//             });
//         } else if (config.name === 'ML Chatbot history') {
//             Object.entries(values).forEach(([key, val]) => {
//                 let processedValue;
//                 if (typeof val === 'object' && val !== null && val.value) {
//                     processedValue = [val.value];
//                 } else {
//                     processedValue = [String(val)];
//                 }
//                 configValue.push({
//                     key: key,
//                     value: processedValue
//                 });
//             });
//         } else if (config.name === 'agenticai.endpoints' || config.name === 'agenticai.apikey') {
//             Object.entries(values).forEach(([key, val]) => {
//                 configValue.push({
//                     key: key,
//                     value: [String(val)]
//                 });
//             });
//         } else {
//             if (config.name === 'identityManagement') {
//                 if (values['IdentityProvider'] === 'Keycloak') {
//                     if (values['IdentityProvider.Azure'] === true) {
//                         values['IdentityProvider'] = ["Keycloak", "Azure"];
//                     } else if (values['IdentityProvider.Google'] === true) {
//                         values['IdentityProvider'] = ["Keycloak", "Google"];
//                     }
//                 }
//             }
//             Object.entries(values).forEach(([key, value]) => {
//                 let processedValue;

//                 if (typeof value === 'boolean') {
//                     processedValue = [value ? 'True' : 'False'];
//                 } else if (typeof value === 'object' && value !== null && value.value) {
//                     processedValue = [value.value];
//                 } else if (Array.isArray(value) && value.length > 1){
//                     const valArr = value.map(val => val.value ? val.value : val)
//                     processedValue = valArr
//                 } else if (Array.isArray(value)) {
//                     processedValue = value.value;
//                 } else {
//                     processedValue = [String(value)];
//                 }
//                 configValue.push({
//                     key: key,
//                     value: processedValue
//                 });
//                 if (config.name === "paymentManagement" && key === "PaymentProvider") {
//                     configValue.push({
//                         key: "PaymentStatus",
//                         value: ["ACTIVE"]
//                     });
//                 }
//             });
//         }


//         configurations.push({
//             name: config.name,
//             value: configValue,
//             operatorId: response?.data?.adminDetails?.operatorId || response?.operatorId,
//             type: config.type,
//             inheritable: config.inheritable,
//             level: config.level,
//             overrideable: config.overrideable,
//         });
//     });

//     return configurations;
// };
export const buildConfigurationPayload = (switchState, systemDefaults, response) => {
    const configurations = {};

    const findConfigByKey = (searchKey) => {

        if (searchKey === 'csv' || searchKey === 'datalake') {
            const config = systemDefaults.find(c => c.name === 'MLDatasource');
            if (config) {
                return { config, keyName: searchKey };
            }
        }

        const parts = searchKey.split('.');

        for (const config of systemDefaults) {
            const found = config.value.find(item => item.key === searchKey);
            if (found) {
                return { config, keyName: found.key };
            }
        }

        if (parts.length >= 2) {
            const configName = parts[0];
            const keyName = parts.slice(1).join('.');
            const config = systemDefaults.find(c => c.name === configName);
            if (config) {
                const found = config.value.find(item => item.key === keyName);
                if (found) {
                    return { config, keyName: found.key };
                }
            }
        }

        if (parts.length >= 3) {
            const possibleConfigName = parts.slice(0, 2).join('.');
            const keyName = parts.slice(2).join('.');
            const config = systemDefaults.find(c => c.name === possibleConfigName);
            if (config) {
                const found = config.value.find(item => item.key === keyName);
                if (found) {
                    return { config, keyName: found.key };
                }
            }
        }

        if (searchKey === "EIP") {
            const config = systemDefaults.find(c => c.name === 'EIP');
            if (config) {
                return { config, keyName: "Enabled" };
            }
        }

        return null;
    };

    const groupedConfigs = new Map();

    Object.entries(switchState).forEach(([stateKey, value]) => {
        const configInfo = findConfigByKey(stateKey);
        if (!configInfo) return;

        const { config, keyName } = configInfo;

        if (!groupedConfigs.has(config.name)) {
            groupedConfigs.set(config.name, {
                config,
                values: {}
            });
        }

        groupedConfigs.get(config.name).values[keyName] = value;
    });

    groupedConfigs.forEach(({ config, values }) => {

        const formattedValues = {};

        // 🔥 Special Case: MLDatasource
        if (config.name === 'MLDatasource') {
            const datasources = [];

            Object.entries(values).forEach(([key, val]) => {
                if (key === 'csv' && val) datasources.push('csv');
                if (key === 'datalake' && val) datasources.push('datalake');
            });

            formattedValues['Datasource'] = {
                value: datasources,
            };
        }

        // 🔥 Special Case: AgenticAI / SessionExpiryTime / ML Chatbot history
        else if (
            config.name === 'AgenticAI' ||
            config.name === 'SessionExpiryTime' ||
            config.name === 'ML Chatbot history'
        ) {
            Object.entries(values).forEach(([key, val]) => {

                let processedValue;

                if (typeof val === 'object' && val !== null && val.value) {
                    processedValue = val.value;
                }
                else if (!isNaN(val) && val !== "") {
                    processedValue = Number(val);
                }
                else {
                    processedValue = val;
                }

                formattedValues[key] = {
                    value: processedValue,
                };
            });
        }

        // 🔥 Special Case: agenticai endpoints / apikey
        else if (
            config.name === 'agenticai.endpoints' ||
            config.name === 'agenticai.apikey'
        ) {
            Object.entries(values).forEach(([key, val]) => {
                formattedValues[key] = {
                    value: val,
                };
            });
        }

        // 🔥 Default Logic
        else {

            // identityManagement special logic
            if (config.name === 'identityManagement') {
                if (values['IdentityProvider'] === 'Keycloak') {
                    if (values['IdentityProvider.Azure'] === true) {
                        values['IdentityProvider'] = ["Keycloak", "Azure"];
                    } else if (values['IdentityProvider.Google'] === true) {
                        values['IdentityProvider'] = ["Keycloak", "Google"];
                    }
                }
            }

            Object.entries(values).forEach(([key, value]) => {

                let processedValue;

                if (typeof value === 'boolean') {
                    processedValue = value;
                }
                else if (typeof value === 'object' && value !== null && value.value) {
                    processedValue = value.value;
                }
                else if (Array.isArray(value)) {
                    processedValue = value.map(val => val?.value ?? val);
                }
                else if (!isNaN(value) && value !== "") {
                    processedValue = Number(value);
                }
                else if (value === "true" || value === "false") {
                    processedValue = value === "true";
                }
                else {
                    processedValue = value;
                }

                formattedValues[key] = {
                    value: processedValue,
                };

                // paymentManagement special logic
                if (config.name === "paymentManagement" && key === "PaymentProvider") {
                    formattedValues["PaymentStatus"] = {
                        value: "ACTIVE",
                    };
                }
            });
        }

        configurations[config.name] = {
            type: config.type,
            inheritable: config.inheritable,
            level: config.level,
            overrideable: config.overrideable,
            operatorId:
                response?.data?.adminDetails?.operatorId ||
                response?.operatorId,
            value: formattedValues
        };
    });

    return configurations;
};
export const createConfigArray = (finalValue, response) => {
    const config = {};

    const taskEnabledValue = finalValue["TaskEnabled"];
    const brmTaskEnabledValue = finalValue["BRMTaskEnabled"];

    const paymentProviderValue = finalValue["PaymentProvider"];
    const identityProviderValue = finalValue["IdentityProvider"];

    // Azure configuration values
    const azureTenantId = finalValue["IdentityProvider.Azure.tenantId"];
    const azureClientId = finalValue["IdentityProvider.Azure.clientId"];
    const azureClientSecret = finalValue["IdentityProvider.Azure.clientSecret"];

    // Google configuration values
    const googleClientId = finalValue["IdentityProvider.Google.clientId"];
    const googleClientSecret = finalValue["IdentityProvider.Google.clientSecret"];

    const customerSearchValue = finalValue["CustomerSearch"]
    const customerListingValue = finalValue["CustomerListing"]

    const limit = finalValue["Limit"]

    const ExpiryInSeconds = finalValue["ExpiryInSeconds"]

    const mode = finalValue["Mode"]

    const CustomerPrefix = finalValue["CustomerPrefix"]
    const SubscriptionPrefix = finalValue["SubscriptionPrefix"]
    const OrderPrefix = finalValue["OrderPrefix"]
    const CustomerSequence = finalValue["CustomerSequence"]
    const SubscriptionSequence = finalValue["SubscriptionSequence"]
    const OrderSequence = finalValue["OrderSequence"]
    const currencyCode = finalValue["defaultCurrency"] || finalValue["CurrencyCode"] || "USD"
    const Category = Array.isArray(finalValue?.["CustomerCategory"]) ? finalValue["CustomerCategory"]?.map((category) => category?.label) : []
    const datasetVersion = finalValue["datasetVersion"]

    // List of notification keys
    const notificationKeys = [
        "SetPassword",
        "ProfileUpdate",
        "EmailUpdate",
        "BalanceNotification",
        "BalanceAVNotification",
        "CreateCustomer",
        "CustomerUpdate",
        "AddOnPurchase",
        "PurchaseOffer",
        "UnsubscribeEmail",
        "ChangePlan",
        "PaymentOrder",
        "PaymentConfirmation",
        "CancelProductOrder",
        "SubscriptionFailed",
        "SubscriptionConfirmed",
        "CommissionStatement",
        "PasswordReset",
        "CreditLimitNotification",
        "PaygNotification",
        "ThresholdNotification",
        "ModelTrainingComplete",
        "BatchPredictionComplete"
    ];

    // Determine if NotificationEnable should be true
    const isAnyNotificationEnabled = notificationKeys.some(key =>
        finalValue[key] === true || finalValue[key] === "true"
    );

    // Helper function to add parent config
    const addParentConfig = (name, category, scope = ["systemUser", "providerOperationUser"]) => {
        if (!config[name]) {
            config[name] = {
                name: name,
                value: [],
                operatorId: response?.data?.adminDetails?.operatorId || response?.operatorId,
                type: response?.data?.domain || response?.domain || "SGC",
                level: "Operator",
                inheritable: false,
                overrideable: false,
                category: category,
                scope: scope,
                versionId: 1
            };
        }
    };
    // Add parent configurations for hierarchical configs
    const parentConfigs = [
        { key: "GlobalFilter", category: "Filters" },
        { key: "ProviderView", category: "Widget Views" },
        { key: "ProcedureView", category: "Widget Views" },
        { key: "MetricView", category: "Widget Views" },
        { key: "ProviderScorecard", category: "Widget Properties" },
        { key: "ColumnSelection", category: "Widget Properties" },
        { key: "Minimize/Maximize", category: "Widget Properties" },
        { key: "ColumnSorting", category: "Widget Properties" },
        { key: "ColumnReorganizing", category: "Widget Properties" },
    ];

    // Update the parentConfigs section
    parentConfigs.forEach(({ key, category }) => {
        // Always add parent config if it exists in finalValue (even if false)
        if (finalValue[key] !== undefined) {
            addParentConfig(key, category);
            // Add parent toggle
            if (!config[key].value.some(item => item.key === key)) {
                config[key].value.push({
                    key: key,
                    value: [finalValue[key] ? "True" : "False"]
                });
            }
            // Add children and sub-children
            Object.entries(finalValue).forEach(([childKey, childValue]) => {
                if (childKey.startsWith(key + ".")) {
                    if (!config[key].value.some(item => item.key === childKey)) {
                        config[key].value.push({
                            key: childKey,
                            value: [childValue ? "True" : "False"]
                        });
                    }
                }
            });
        }
    });


    Object.entries(finalValue).forEach(([key, value]) => {
        let managementName = '';
        const managementNameMapping = {
            "Payment": "PaymentManagement",
            "IdentityProvider": "identityManagement",
            "whatsApp": "whatsAppManagement",
            "notificationEnable": "NotificationManagement",
            "NotificationEnable": "NotificationManagement",
            "Task": "TaskManagement",
            "policy": "policySpecifications",
            "Customer": "CustomerRetrieval",
            "self": "selfcare",
            "order": "orderManagement",
            "Billing": "BillingManagement",
            "LLM": "LLM",
            "Session": "SessionAudit",
            "Usage": "UsageEventsPersistanceMode",
            "usage": "UsageEventsPersistanceMode",
            "reservation": "ReservationUnitsExpiration",
            "sessionAuditBuffer": "SessionAuditBuffer",
            "rated": "Rated Event Consumer Configuration",
            "tax": "taxManagement",
            "prefixes": "Prefixes",
            "sequenceHandling": "SequenceHandling",
            "EIP": "EIP",
            "ML": "ML",
            "Currency": "DefaultCurrency",
            "defaultCurrency": "DefaultCurrency",
            "CustomerCategory": "CustomerCategory",
            "Duration": "ML Chatbot history",
            "Interval": "RetentionInterval",
            "SessionExpiryBufferValue": "SessionExpiryBuffer",
            "SessionExpiryType": "SessionExpiryTime",
            "Days": "SubscribedOfferExpiryTime",
            "SessionExpiryBufferValue": "SessionExpiryBuffer",
            "csv": "MLDatasource",
            "datalake": "MLDatasource",
            "ChatMode": "ChatMode",
            "ChatPanel": "ChatPanel",
            "datasetVersion": "datasetVersion"
        };

        function getManagementName(key) {
            let managementName = null;

            Object.entries(managementNameMapping).forEach(([prefix, name]) => {
                if (prefix === "Task" && key.includes(prefix)) {
                    managementName = name
                }
                else if (prefix === "Customer" && key.includes(prefix)) {
                    managementName = name
                }
                else if (prefix === "IdentityProvider" && key.includes(prefix)) {
                    managementName = name;
                }
                else if (key.startsWith(prefix)) {
                    managementName = name;
                }
            });

            return managementName;
        }

        managementName = getManagementName(key)

        if (managementName) {
            if (!config[managementName]) {
                config[managementName] = {
                    name: managementName,
                    value: [],
                    scope: ["systemUser", "providerUser"],
                    operatorId: response?.data?.adminDetails?.operatorId || response?.operatorId,
                    type: response?.data?.domain || response?.domain,
                    level: "Operator",
                };
            }

            const managementConfig = {
                "whatsAppManagement": [
                    { key: "WhatsAppEnable", value: value ? "True" : "False" }
                ],
                "PaymentManagement": [
                    { key: "PaymentProvider", value: paymentProviderValue },
                    { key: "PaymentStatus", value: (paymentProviderValue !== "") ? "ACTIVE" : "INACTIVE" }
                ],
                "TaskManagement": [
                    { key: "TaskEnabled", value: formatValue(taskEnabledValue) },
                    { key: "BRMTaskEnabled", value: formatValue(brmTaskEnabledValue) }
                ],
                "identityManagement": [
                    { key: "IdentityProvider", value: identityProviderValue },
                    { key: "IdentityProvider.Native", value: identityProviderValue === "Native" ? "True" : "False" },
                    { key: "IdentityProvider.Azure", value: identityProviderValue === "Azure" ? "True" : "False" },
                    ...(identityProviderValue === "Azure" ? [
                        { key: "IdentityProvider.Azure.tenantId", value: azureTenantId || "" },
                        { key: "IdentityProvider.Azure.clientId", value: azureClientId || "" },
                        { key: "IdentityProvider.Azure.clientSecret", value: azureClientSecret || "" }
                    ] : []),
                    { key: "IdentityProvider.Google", value: identityProviderValue === "Google" ? "True" : "False" },
                    ...(identityProviderValue === "Google" ? [
                        { key: "IdentityProvider.Google.clientId", value: googleClientId || "" },
                        { key: "IdentityProvider.Google.clientSecret", value: googleClientSecret || "" }
                    ] : [])
                ],
                "policySpecifications": [
                    { key: "PolicyEnabled", value: value ? "True" : "False" },
                ],
                "orderManagement": [
                    { key: "OrderEnabled", value: value ? "True" : "False" }
                ],
                "EIP": [
                    { key: "Enabled", value: value ? "True" : "False" }
                ],
                "ML": [
                    { key: "MLEnabled", value: value ? "True" : "False" }
                ],
                "NotificationManagement": [
                    { key: "NotificationEnable", value: isAnyNotificationEnabled ? "True" : "False" },
                    { key: "SetPassword", value: finalValue["SetPassword"] ? "True" : "False" },
                    { key: "ProfileUpdate", value: finalValue["ProfileUpdate"] ? "True" : "False" },
                    { key: "EmailUpdate", value: finalValue["EmailUpdate"] ? "True" : "False" },
                    { key: "BalanceNotification", value: finalValue["BalanceNotification"] ? "True" : "False" },
                    { key: "BalanceAVNotification", value: finalValue["BalanceAVNotification"] ? "True" : "False" },
                    { key: "CreateCustomer", value: finalValue["CreateCustomer"] ? "True" : "False" },
                    { key: "CustomerUpdate", value: finalValue["CustomerUpdate"] ? "True" : "False" },
                    { key: "AddOnPurchase", value: finalValue["AddOnPurchase"] ? "True" : "False" },
                    { key: "PurchaseOffer", value: finalValue["PurchaseOffer"] ? "True" : "False" },
                    { key: "UnsubscribeEmail", value: finalValue["UnsubscribeEmail"] ? "True" : "False" },
                    { key: "ChangePlan", value: finalValue["ChangePlan"] ? "True" : "False" },
                    { key: "PaymentOrder", value: finalValue["PaymentOrder"] ? "True" : "False" },
                    { key: "PaymentConfirmation", value: finalValue["PaymentConfirmation"] ? "True" : "False" },
                    { key: "CancelProductOrder", value: finalValue["CancelProductOrder"] ? "True" : "False" },
                    { key: "SubscriptionFailed", value: finalValue["SubscriptionFailed"] ? "True" : "False" },
                    { key: "SubscriptionConfirmed", value: finalValue["SubscriptionConfirmed"] ? "True" : "False" },
                    { key: "CommissionStatement", value: finalValue["CommissionStatement"] ? "True" : "False" },
                    { key: "PasswordReset", value: finalValue["PasswordReset"] ? "True" : "False" },
                    { key: "CreditLimitNotification", value: finalValue["CreditLimitNotification"] ? "True" : "False" },
                    { key: "PaygNotification", value: finalValue["PaygNotification"] ? "True" : "False" },
                    { key: "ThresholdNotification", value: finalValue["ThresholdNotification"] ? "True" : "False" },
                    { key: "ModelTrainingComplete", value: finalValue["ModelTrainingComplete"] ? "True" : "False" },
                    { key: "BatchPredictionComplete", value: finalValue["BatchPredictionComplete"] ? "True" : "False" },
                ],
                "CustomerRetrieval": [
                    { key: "CustomerSearch", value: formatValue(customerSearchValue) },
                    { key: "CustomerListing", value: formatValue(customerListingValue) }
                ],
                "BillingManagement": [
                    { key: "BillingEnabled", value: value ? "True" : "False" }
                ],
                "SessionAuditBuffer": [
                    { key: "Limit", value: (limit !== "" ? limit : "10") }
                ],
                "LLM": [
                    { key: "LLMEnabled", value: value ? "True" : "False" }
                ],
                "SessionAudit": [
                    { key: "Enabled", value: value ? "True" : "False" }
                ],
                "UsageEventsPersistanceMode": [
                    { key: "Mode", value: (!mode ? "None" : mode) },
                ],
                "ReservationUnitsExpiration": [
                    { key: "ExpiryInSeconds", value: (ExpiryInSeconds !== "" ? ExpiryInSeconds : "3600") }
                ],
                "Rated Event Consumer Configuration": [
                    { key: "Trigger One Bill API", value: finalValue["Trigger One Bill API"] ? "true" : "false" },
                    { key: "Generate CSV File", value: finalValue["Generate CSV File"] ? "true" : "false" }
                ],
                "taxManagement": [
                    { key: "taxEnabled", value: value ? "True" : "False" }
                ],
                "selfcare": [
                    { key: "SelfcareEnabled", value: value ? "True" : "False" }
                ],
                "Prefixes": [
                    { key: "CustomerPrefix", value: (CustomerPrefix !== "" ? CustomerPrefix : "CUST") },
                    { key: "SubscriptionPrefix", value: (SubscriptionPrefix !== "" ? SubscriptionPrefix : "CUST") },
                    { key: "OrderPrefix", value: (OrderPrefix !== "" ? OrderPrefix : "CUST") },
                ],
                "SequenceHandling": [
                    { key: "CustomerSequence", value: (CustomerSequence !== "" ? CustomerSequence : "01") },
                    { key: "SubscriptionSequence", value: (SubscriptionSequence !== "" ? SubscriptionSequence : "01") },
                    { key: "OrderSequence", value: (OrderSequence !== "" ? OrderSequence : "01") },
                ],
                "DefaultCurrency": [
                    { key: "CurrencyCode", value: (currencyCode || "") }
                ],
                "CustomerCategory": [
                    { key: "Categories", value: (Category || "") }
                ],
                "ML Chatbot history": [
                    { key: "Retention Period", value: (finalValue["RetentionPeriod"] || "") },
                    { key: "Duration", value: (finalValue["Duration"] || "") }
                ],
                "RetentionInterval": [
                    { key: "Interval", value: (finalValue["Interval"] || "21600") }
                ],
                "SessionExpiryBuffer": [
                    { key: "SessionExpiryBufferValue", value: (finalValue["SessionExpiryBufferValue"] || "10") }
                ],
                "SessionExpiryTime": [
                    { key: "SessionExpiryType", value: (finalValue["SessionExpiryType"] || "hour") },
                    { key: "SessionExpiryValue", value: (finalValue["SessionExpiryValue"] || "12") }
                ],
                "SubscribedOfferExpiryTime": [
                    { key: "Days", value: (finalValue["Days"] || "10") }
                ],
                "MLDatasource": [
                    { key: "Datasource", value: (finalValue["csv"] || finalValue["datalake"]) ? [...(finalValue["csv"] ? ["csv"] : []), ...(finalValue["datalake"] ? ["datalake"] : []),] : ["csv"] }
                ],
                "ChatMode": [
                    { key: "ChatMode", value: value ? "True" : "False" }
                ],
                "ChatPanel": [
                    { key: "ChatPanel", value: value ? "True" : "False" }
                ],
                "datasetVersion": [
                    { key: "datasetVersion", value: (finalValue["datasetVersion"] || "") }
                ]
            };
            if (managementConfig[managementName]) {
                managementConfig[managementName].forEach(item => {
                    if (!config[managementName].value.some(existingItem => existingItem.key === item.key)) {
                        if (managementName === "CustomerCategory" || managementName === "MLDatasource") {
                            config[managementName].value.push({
                                key: item.key,
                                value: item.value
                            });
                        } else {
                            config[managementName].value.push({
                                key: item.key,
                                value: [item.value]
                            });
                        }
                    }
                });
            } else {
                const formattedValue = formatValue(value);
                if (!config[managementName].value.some(item => item.key === key)) {
                    config[managementName].value.push({
                        key: key,
                        value: [formattedValue]
                    });
                }
            }
        }
    });
    return Object.values(config);
};

export const combinedConfigurations = (OperatorDefaultConfigurationList) => {
    const configList = [...OperatorDefaultConfigurationList];

    const paymentIndex = configList.findIndex(config => config.name === "paymentManagement");
    const identityIndex = configList.findIndex(config => config.name === "identityManagement");

    if (paymentIndex !== -1 && identityIndex !== -1) {
        const identityConfig = configList.splice(identityIndex, 1)[0];
        configList.splice(paymentIndex + 1, 0, identityConfig);
    }

    return configList;
};

export const mapConfig = (isEdit, configData, OperatorDefaultConfigurationList, setSwitchState, setSelectState,
    setTempSelectState, setTempSwitchState
) => {
    const initialSwitchState = {};
    const initialSelectState = {};

    const config = isEdit ? configData?.configurations : OperatorDefaultConfigurationList
    config?.forEach(config => {
        const camelizedName = camelize(config.name);
        if (!isEdit) {
            if (config.name === "paymentManagement" || config.name === "identityManagement") {
                initialSelectState[config.value[0].key] = { label: "", value: "" }
            } else {
                initialSwitchState[config.name] = false;
                config.value?.forEach((val) => {
                    if (val?.key) {
                        const childKey = val.key.replace(/\s+/g, "");
                        initialSwitchState[childKey] = false;
                    }
                });
            }
        }
        else {
            const notificationKeys = [
                "SetPassword",
                "ProfileUpdate",
                "EmailUpdate",
                "BalanceNotification",
                "BalanceAVNotification",
                "CreateCustomer",
                "CustomerUpdate",
                "AddOnPurchase",
                "PurchaseOffer",
                "UnsubscribeEmail",
                "ChangePlan",
                "PaymentOrder",
                "PaymentConfirmation",
                "CancelProductOrder",
                "SubscriptionFailed",
                "SubscriptionConfirmed",
                "CommissionStatement",
                "PasswordReset",
                "CreditLimitNotification",
                "PaygNotification",
                "ThresholdNotification",
                "ModelTrainingComplete",
                "BatchPredictionComplete"
            ];

            let isAnyNotificationEnabled = false;
            const newConfigNames = [
                "GlobalFilter",
                "ProviderView",
                "ProcedureView",
                "MetricView",
                "ProviderScorecard",
                "ColumnSelection",
                "Minimize/Maximize",
                "ColumnSorting",
                "ColumnReorganizing",
            ];

            if (newConfigNames.includes(config.name)) {
                config.value?.forEach((val) => {
                    const keyName = val.key;
                    const firstVal = val?.value?.[0];
                    const value = firstVal === "True" ? true : firstVal === "False" ? false : firstVal;
                    initialSwitchState[keyName] = value;
                });

                const parentVal =
                    config.value?.find((v) => v.key === config.name)?.value?.[0] === "True";
                initialSwitchState[config.name] = parentVal ?? false;

                return;
            }


            config.value.forEach((val) => {
                const switchStateMapping = {
                    "WhatsAppEnable": { target: "whatsAppManagement", transform: (value) => value === "True" },
                    "PaymentStatus": { target: "paymentManagement", transform: (value) => value === "ACTIVE" },
                    "Enable": { target: "identityManagement", transform: (value) => value === "True" },
                    "IdentityProvider.Native": { target: "IdentityProvider", transform: (value) => value === "True" ? "Native" : null },
                    "IdentityProvider.Azure": { target: "IdentityProvider", transform: (value) => value === "True" ? "Azure" : null },
                    "IdentityProvider.Azure.tenantId": { target: "IdentityProvider.Azure.tenantId", transform: (value) => value },
                    "IdentityProvider.Azure.clientId": { target: "IdentityProvider.Azure.clientId", transform: (value) => value },
                    "IdentityProvider.Azure.clientSecret": { target: "IdentityProvider.Azure.clientSecret", transform: (value) => value },
                    "IdentityProvider.Google": { target: "IdentityProvider", transform: (value) => value === "True" ? "Google" : null },
                    "IdentityProvider.Google.clientId": { target: "IdentityProvider.Google.clientId", transform: (value) => value },
                    "IdentityProvider.Google.clientSecret": { target: "IdentityProvider.Google.clientSecret", transform: (value) => value },
                    "TaskEnabled": { target: "TaskEnabled", transform: (value) => value === "True" },
                    "BRMTaskEnabled": { target: "BRMTaskEnabled", transform: (value) => value === "True" },
                    "CustomerSearch": { target: "CustomerSearch", transform: (value) => value === "True" },
                    "CustomerListing": { target: "CustomerListing", transform: (value) => value === "True" },
                    "OrderEnabled": { target: "orderManagement", transform: (value) => value === "True" },
                    "SelfcareEnabled": { target: "selfcare", transform: (value) => value === "True" },
                    "NotificationEnable": { target: "NotificationEnable", transform: (value) => value === "True" },
                    "SetPassword": { target: "SetPassword", transform: (value) => value === "True" },
                    "ProfileUpdate": { target: "ProfileUpdate", transform: (value) => value === "True" },
                    "EmailUpdate": { target: "EmailUpdate", transform: (value) => value === "True" },
                    "BalanceNotification": { target: "BalanceNotification", transform: (value) => value === "True" },
                    "BalanceAVNotification": { target: "BalanceAVNotification", transform: (value) => value === "True" },
                    "CreateCustomer": { target: "CreateCustomer", transform: (value) => value === "True" },
                    "CustomerUpdate": { target: "CustomerUpdate", transform: (value) => value === "True" },
                    "AddOnPurchase": { target: "AddOnPurchase", transform: (value) => value === "True" },
                    "PurchaseOffer": { target: "PurchaseOffer", transform: (value) => value === "True" },
                    "UnsubscribeEmail": { target: "UnsubscribeEmail", transform: (value) => value === "True" },
                    "ChangePlan": { target: "ChangePlan", transform: (value) => value === "True" },
                    "PaymentOrder": { target: "PaymentOrder", transform: (value) => value === "True" },
                    "PaymentConfirmation": { target: "PaymentConfirmation", transform: (value) => value === "True" },
                    "CancelProductOrder": { target: "CancelProductOrder", transform: (value) => value === "True" },
                    "SubscriptionFailed": { target: "SubscriptionFailed", transform: (value) => value === "True" },
                    "SubscriptionConfirmed": { target: "SubscriptionConfirmed", transform: (value) => value === "True" },
                    "CommissionStatement": { target: "CommissionStatement", transform: (value) => value === "True" },
                    "BillingEnabled": { target: "BillingManagement", transform: (value) => value === "True" },
                    "Trigger One Bill API": { target: "Trigger One Bill API", transform: (value) => value === "true" },
                    "Generate CSV File": { target: "Generate CSV File", transform: (value) => value === "true" },
                    "LLMEnabled": { target: "LLM", transform: (value) => value === "True" },
                    "Mode": { target: "Mode", transform: (value) => value },
                    "IdentityProvider": { target: "IdentityProvider", transform: (value) => value },
                    "CurrencyCode": { target: "CurrencyCode", transform: (value) => value },
                    "Limit": { target: "Limit", transform: (value) => value },
                    "Enabled": { target: "SessionAudit", transform: (value) => value === "True" },
                    "ExpiryInSeconds": { target: "ExpiryInSeconds", transform: (value) => value },
                    "CreditLimitNotification": { target: "CreditLimitNotification", transform: (value) => value === "True" },
                    "PaygNotification": { target: "PaygNotification", transform: (value) => value === "True" },
                    "ThresholdNotification": { target: "ThresholdNotification", transform: (value) => value === "True" },
                    "ModelTrainingComplete": { target: "ModelTrainingComplete", transform: (value) => value === "True" },
                    "BatchPredictionComplete": { target: "BatchPredictionComplete", transform: (value) => value === "True" },
                    "PasswordReset": { target: "PasswordReset", transform: (value) => value === "True" },
                    "taxEnabled": { target: "taxManagement", transform: (value) => value === "True" },
                    "PolicyEnabled": { target: "policySpecifications", transform: (value) => value === "True" },
                    "CustomerPrefix": { target: "CustomerPrefix", transform: (value) => value },
                    "SubscriptionPrefix": { target: "SubscriptionPrefix", transform: (value) => value },
                    "OrderPrefix": { target: "OrderPrefix", transform: (value) => value },
                    "CustomerSequence": { target: "CustomerSequence", transform: (value) => value },
                    "OrderSequence": { target: "OrderSequence", transform: (value) => value },
                    "SubscriptionSequence": { target: "SubscriptionSequence", transform: (value) => value },
                    "Enabled": { target: "EIP", transform: (value) => value === "True" },
                    "MLEnabled": { target: "ML", transform: (value) => value === "True" },
                    "Categories": { target: "CustomerCategory", transform: (value) => value },
                    "Duration": { target: "Duration", transform: (value) => value },
                    "Retention Period": { target: "RetentionPeriod", transform: (value) => value },
                    "Interval": { target: "Interval", transform: (value) => value },
                    "SessionExpiryType": { target: "SessionExpiryType", transform: (value) => value },
                    "SessionExpiryValue": { target: "SessionExpiryValue", transform: (value) => value },
                    "SessionExpiryBufferValue": { target: "SessionExpiryBufferValue", transform: (value) => value },
                    "Days": { target: "Days", transform: (value) => value },
                    "ChatMode": { target: "ChatMode", transform: (value) => value === "True" },
                    "ChatPanel": { target: "ChatPanel", transform: (value) => value === "True" },
                    "datasetVersion": { target: "datasetVersion", transform: (value) => value },
                    [camelizedName]: { target: camelizedName, transform: (value) => value === "True" },
                };

                const selectStateMapping = {
                    "PaymentProvider": { target: "PaymentProvider", transform: (value) => ({ label: value, value: value }) },
                    "IdentityProvider": { target: "IdentityProvider", transform: (value) => ({ label: value, value: value }) }
                };

                if (switchStateMapping[val.key]) {
                    if (val.key === "Categories") {
                        initialSwitchState[switchStateMapping[val.key].target] = val.value.map((category) => ({ label: category, value: category, __isNew__: false }));
                    } else if (val.key === "IdentityProvider.Native" || val.key === "IdentityProvider.Azure" || val.key === "IdentityProvider.Google") {
                        // Handle identity provider selection
                        const provider = switchStateMapping[val.key].transform(val?.value?.[0] ?? "");
                        if (provider) {
                            initialSwitchState["IdentityProvider"] = provider;
                        }
                    } else if (val.key.startsWith("IdentityProvider.Azure.") || val.key.startsWith("IdentityProvider.Google.")) {
                        // Handle Azure and Google configuration fields
                        initialSwitchState[switchStateMapping[val.key].target] = switchStateMapping[val.key].transform(val?.value?.[0] ?? "");
                    } else {
                        initialSwitchState[switchStateMapping[val.key].target] = switchStateMapping[val.key].transform(val?.value?.[0] ?? "");
                    }
                } else if (val.key === "Datasource") {
                    const sources = val.value || [];
                    initialSwitchState["csv"] = sources.includes("csv");
                    initialSwitchState["datalake"] = sources.includes("datalake");
                }

                if (selectStateMapping[val.key]) {
                    initialSelectState[selectStateMapping[val.key].target] = selectStateMapping[val.key].transform(val?.value[0]);
                }

                // Check if any notification key is enabled
                if (notificationKeys.includes(val.key)) {
                    const isEnabled = switchStateMapping[val.key].transform(val?.value[0]);
                    if (isEnabled) {
                        isAnyNotificationEnabled = true;
                    }
                }
            });

            // Set NotificationEnable based on other notification keys
            initialSwitchState["NotificationEnable"] = isAnyNotificationEnabled;

            initialSwitchState["customerRetrieval"] = (initialSwitchState["CustomerSearch"] || initialSwitchState["CustomerListing"])
            initialSwitchState["ratedEventConsumerConfiguration"] = (initialSwitchState["Trigger One Bill API"] || initialSwitchState["Generate CSV File"])
            initialSwitchState["UsageEventsPersistanceMode"] = (initialSwitchState["Mode"] && initialSwitchState["Mode"] !== "None")
            initialSwitchState["sessionAuditBuffer"] = (initialSwitchState["Limit"])
            initialSwitchState["reservationUnitsExpiration"] = (initialSwitchState["ExpiryInSeconds"])
            initialSwitchState["prefixes"] = false
            initialSwitchState["sequenceHandling"] = false
            initialSelectState["PaymentProvider"] = initialSelectState["PaymentProvider"] || { label: "", value: "" }
            initialSelectState["IdentityProvider"] = initialSelectState["IdentityProvider"] || { label: "", value: "" }
            initialSwitchState["CurrencyCode"] = initialSwitchState["CurrencyCode"] || "USD"
        }
    });

    setSwitchState(initialSwitchState);
    setTempSwitchState(initialSwitchState);
    setSelectState(initialSelectState);
    setTempSelectState(initialSelectState);
}

export const mapConfigurationsToSwitchState = (configurationsResponse, setSwitchState, defaultConfigurations, isEdit) => {
    const switchState = {};
    const config = isEdit ? configurationsResponse?.configurations : defaultConfigurations
    if (!isEdit) {
        setSwitchState(prev => {
            const updated = { ...prev };

            updated[config.name] = false;

            Object.keys(config.value || {}).forEach(key => {
                updated[key] = false;
            });
            return {
                ...updated,
                "SessionAuditBuffer.Limit": "10",
                ExpiryInSeconds: "3600",
                "Prefixes.CustomerPrefix": "CUS",
                "Prefixes.SubscriptionPrefix": "SUB",
                "Prefixes.OrderPrefix": "ODR",
                "SequenceHandling.CustomerSequence": "01",
                "SequenceHandling.SubscriptionSequence": "01",
                "SequenceHandling.OrderSequence": "01",
                "RetentionInterval.Interval": "216000",
                SessionExpiryBufferValue: "5",
                SessionExpiryType: "hour",
                SessionExpiryValue: "6",
                "SubscribedOfferExpiryTime.Days": "10",
                IdentityProvider: "Native",
            };
        });

    }
    else {
        // config?.forEach((config) => {
        //     const configName = config.name;
        //     if (configName === 'MLDatasource') {
        //         const datasourceItem = config.value.find(item => item.key === 'Datasource');
        //         if (datasourceItem && Array.isArray(datasourceItem.value)) {
        //             switchState.csv = datasourceItem.value.includes('csv');
        //             switchState.datalake = datasourceItem.value.includes('datalake');
        //         }
        //     } else if (configName === 'AgenticAI') {
        //         config.value.forEach((item) => {
        //             if (item.key === 'Provider' || item.key === 'Model') {
        //                 switchState[item.key] = {
        //                     label: item.value[0],
        //                     value: item.value[0]
        //                 };
        //             } else {
        //                 switchState[item.key] = item.value[0];
        //             }
        //         });
        //     } else if (configName === 'ML Chatbot history') {
        //         config.value.forEach((item) => {
        //             if (item.key === 'Retention Period') {
        //                 switchState['Retention Period'] = {
        //                     label: item.value[0].charAt(0).toUpperCase() + item.value[0].slice(1),
        //                     value: item.value[0]
        //                 };
        //             } else if (item.key === 'Duration') {
        //                 switchState.Duration = item.value[0];
        //             }
        //         });
        //     } else if (configName === 'SessionExpiryTime') {
        //         config.value.forEach((item) => {
        //             if (item.key === 'SessionExpiryType') {
        //                 switchState.SessionExpiryType = {
        //                     label: item.value[0].charAt(0).toUpperCase() + item.value[0].slice(1),
        //                     value: item.value[0]
        //                 };
        //             } else if (item.key === 'SessionExpiryValue') {
        //                 switchState.SessionExpiryValue = item.value[0];
        //             }
        //         });
        //     } else if (configName === 'UsageEventsPersistanceMode') {
        //         config.value.forEach((item) => {
        //             if (item.key === 'Mode') {
        //                 switchState.Mode = item.value[0];
        //             }
        //         });
        //     } else if (configName === 'agenticai.endpoints' || configName === 'agenticai.apikey') {
        //         config.value.forEach((item) => {
        //             const fullKey = `${configName}.${item.key}`;
        //             switchState[fullKey] = item.value[0];
        //         });
        //     } else if (configName === 'Prefixes' || configName === 'SequenceHandling' ||
        //         configName === 'SessionAuditBuffer' || configName === 'RetentionInterval' || configName === 'SubscribedOfferExpiryTime') {
        //         config.value.forEach((item) => {
        //             const fullKey = `${configName}.${item.key}`;
        //             switchState[fullKey] = item.value[0];
        //         });
        //     } else if (configName === 'Rated Event Consumer Configuration') {
        //         config.value.forEach((item) => {
        //             const value = item.value[0];
        //             switchState[item.key] = value === 'true' || value === 'True';
        //         });
        //     } else {
        //         config.value.forEach((item) => {
        //             const value = item.value[0];
        //             if (value === 'True' || value === 'False') {
        //                 switchState[item.key] = value === 'True';
        //             }
        //             else if (value === 'true' || value === 'false') {
        //                 switchState[item.key] = value === 'true';
        //             }
        //             else {
        //                 if (item.key === "IdentityProvider" && (value === "Azure" || value === "Google"))
        //                     switchState[item.key] = "Keycloak";
        //                 else
        //                     switchState[item.key] = value;
        //             }
        //         });
        //     }
        // });
        Object.entries(config || {}).forEach(([configName, config]) => {
            const values = config?.value || {};

            if (configName === 'MLDatasource') {
                const datasourceItem = values?.Datasource?.value || [];
                if (Array.isArray(datasourceItem)) {
                    switchState.csv = datasourceItem.includes('csv');
                    switchState.datalake = datasourceItem.includes('datalake');
                }
            }

            else if (configName === 'AgenticAI') {
                Object.entries(values).forEach(([key, item]) => {
                    const value = item?.value;

                    if (key === 'Provider' || key === 'Model') {
                        switchState[key] = {
                            label: value,
                            value: value
                        };
                    } else {
                        switchState[key] = value;
                    }
                });
            }

            else if (configName === 'ML Chatbot history') {
                Object.entries(values).forEach(([key, item]) => {
                    const value = item?.value;

                    if (key === 'Retention Period') {
                        switchState['Retention Period'] = {
                            label: value.charAt(0).toUpperCase() + value.slice(1),
                            value: value
                        };
                    } else if (key === 'Duration') {
                        switchState.Duration = value;
                    }
                });
            }

            else if (configName === 'SessionExpiryTime') {
                Object.entries(values).forEach(([key, item]) => {
                    const value = item?.value;

                    if (key === 'SessionExpiryType') {
                        switchState.SessionExpiryType = {
                            label: value.charAt(0).toUpperCase() + value.slice(1),
                            value: value
                        };
                    } else if (key === 'SessionExpiryValue') {
                        switchState.SessionExpiryValue = value;
                    }
                });
            }

            else if (configName === 'UsageEventsPersistanceMode') {
                const value = values?.Mode?.value;
                if (value !== undefined) {
                    switchState.Mode = value;
                }
            }

            else if (configName === 'agenticai.endpoints' || configName === 'agenticai.apikey') {
                Object.entries(values).forEach(([key, item]) => {
                    const fullKey = `${configName}.${key}`;
                    switchState[fullKey] = item?.value;
                });
            }

            else if (
                configName === 'Prefixes' ||
                configName === 'SequenceHandling' ||
                configName === 'SessionAuditBuffer' ||
                configName === 'RetentionInterval' ||
                configName === 'SubscribedOfferExpiryTime'
            ) {
                Object.entries(values).forEach(([key, item]) => {
                    const fullKey = `${configName}.${key}`;
                    switchState[fullKey] = item?.value;
                });
            }

            else if (configName === 'Rated Event Consumer Configuration') {
                Object.entries(values).forEach(([key, item]) => {
                    const value = item?.value;
                    switchState[key] = value === true || value === 'true' || value === 'True';
                });
            }

            else {
                Object.entries(values).forEach(([key, item]) => {
                    let value = item?.value;

                    if (value === 'True' || value === 'False') {
                        switchState[key] = value === 'True';
                    }
                    else if (value === 'true' || value === 'false') {
                        switchState[key] = value === 'true';
                    }
                    else {
                        if (key === "IdentityProvider" && (value === "Azure" || value === "Google")) {
                            switchState[key] = "Keycloak";
                        } else {
                            switchState[key] = value;
                        }
                    }
                });
            }
        });
        setSwitchState(switchState)
    }
    return switchState;
};

export const handleSwitchToggle = (configName, setUseEffectEnabled, setSwitchState) => {
    setUseEffectEnabled(true);
    setSwitchState((prevState) => {
        const newState = { ...prevState, [configName]: !prevState[configName] };

        if (configName === "CustomerSearch" && newState[configName]) {
            newState["CustomerListing"] = false;
        } else if (configName === "CustomerListing" && newState[configName]) {
            newState["CustomerSearch"] = false;
        } else if (configName === "CustomerSearch" && !newState[configName]) {
            newState["CustomerListing"] = true;
        } else if (configName === "CustomerListing" && !newState[configName]) {
            newState["CustomerSearch"] = true;
        }

        return newState;
    });
};

export const brmCheck = (switchState, setSwitchState, setTempSwitchState) => {
    if (!switchState?.TaskEnabled) {
        setSwitchState(prevState => ({
            ...prevState,
            BRMTaskEnabled: false
        }));
        setTempSwitchState(prevState => ({
            ...prevState,
            BRMTaskEnabled: false
        }));
    }
}

export const limitCheck = (useEffectEnabled, isCreate, setSwitchState, setTempSwitchState) => {
    if (!useEffectEnabled && isCreate) {
        setSwitchState((prevState) => ({
            ...prevState,
            Limit: "10",
            ExpiryInSeconds: "3600",
            CustomerPrefix: "CUS",
            SubscriptionPrefix: "SUB",
            OrderPrefix: "ODR",
            CustomerSequence: "01",
            SubscriptionSequence: "01",
            OrderSequence: "01",
            Interval: "216000",
            SessionExpiryBufferValue: "5",
            SessionExpiryType: "hour",
            SessionExpiryValue: "6",
            Days: "10",
            IdentityProvider: "Native"
        }));
        setTempSwitchState((prevState) => ({
            ...prevState,
            Limit: "10",
            ExpiryInSeconds: "3600",
            CustomerPrefix: "CUS",
            SubscriptionPrefix: "SUB",
            OrderPrefix: "ODR",
            Interval: "216000",
            SessionExpiryBufferValue: "5",
            SessionExpiryType: "hour",
            SessionExpiryValue: "6",
            Days: "10",
            CustomerSequence: "01",
            SubscriptionSequence: "01",
            OrderSequence: "01",
            IdentityProvider: "Native"
        }));
    }
}

// export const customerRetrievalCheck = (useEffectEnabled, isCreate, setSwitchState, values, setTempSwitchState) => {
//     if (!useEffectEnabled && isCreate) {
//         setSwitchState((prevState) => ({
//             ...prevState,
//             CustomerSearch: values?.Domain?.label === "Telco",
//             CustomerListing: values?.Domain?.label !== "Telco",
//         }));
//         setTempSwitchState((prevState) => ({
//             ...prevState,
//             CustomerSearch: values?.Domain?.label === "Telco",
//             CustomerListing: values?.Domain?.label !== "Telco",
//         }));
//     }
// }

export const customerRetrievalCheck = (isCreate, setSwitchState, values) => {
    if (isCreate) {
        setSwitchState((prevState) => ({
            ...prevState,
            CustomerSearch: values?.Domain?.label === "Telco",
            CustomerListing: values?.Domain?.label !== "Telco",
        }));
    }
}

export const handleMenuChange = (config, setSelectedMenu, OperatorDefaultConfigurationList, setConfig) => {
    if (config !== 'viewAll') {
        setSelectedMenu(config)
        const configurations = [];
        OperatorDefaultConfigurationList.map((val) => {
            if (val.category === config)
                configurations.push(val)
        })
        setConfig(configurations);
    } else {
        setSelectedMenu('viewAll')
        setConfig(combinedConfigurations(OperatorDefaultConfigurationList))
    }
}

export const categoriesList = (OperatorDefaultConfigurationList) => {
    const categories = [];
    OperatorDefaultConfigurationList.map((val) => {
        if (!categories.includes(val.category) && val?.category !== "")
            categories.push(val.category)
    })
    return categories;
}

export const restructureConfigList = (OperatorDefaultConfigurationList) => {
    const configList = [];
    OperatorDefaultConfigurationList.forEach((config) => {
        const existingConfig = configList.find(item => item.categoryName === config.category);
        if (existingConfig) {
            existingConfig.configList.push(config);
        } else {
            configList.push({
                categoryName: config.category,
                configList: [config]
            });
        }
    });
    return configList;
}

// export const restructureConfigList = (OperatorDefaultConfigurationList) => {
//     const configList = [];
//     let otherConfig = null;
//     OperatorDefaultConfigurationList.forEach((config) => {
//         const existingConfig = configList.find(item => item.categoryName === config.category);
//         if (existingConfig) {
//             existingConfig.configList.push(config);
//         } else {           
//             config.category ? configList.push({
//                 categoryName: config.category,
//                 configList: [config]
//             }) : otherConfig = {
//                 categoryName: "Others",
//                 configList: otherConfig ? [...otherConfig?.configList, config] : [config]
//             };
//         }
//     });
//     otherConfig && configList.push(otherConfig);
//     return configList;
// }